/**
 * Fulhack for IT-2441: rolfsresor.fi shows EUR prices at a hardcoded rate until real
 * Finnish market support is built. The backend and payment gateway stay SEK-denominated,
 * so prices the visitor types are converted back to SEK before they reach an API.
 */
const EUR_SEK_EXCHANGE_RATE = 11

const EUR_CURRENCY_CODE = 'EUR'

const CURRENCY_SYMBOLS: Record<string, string> = {
  sv: ':-',
  pl: 'zł',
  no: ',-',
  'zh-cn': '¥',
  en: '$',
  eur: '€',
}

const SUB_UNIT_DECIMALS = 2

const SPACE = '(?:[\\s\\u00a0\\u2009]|&nbsp;)'

const SPACE_PATTERN = new RegExp(SPACE, 'g')

const SEK_AMOUNT_PATTERN = new RegExp(
  `(^|[^\\d.,])(\\d{1,3}(?:${SPACE}\\d{3})+|\\d+)([.,]\\d{1,2})?${SPACE}*(?::-|kr\\b|sek\\b)`,
  'gi'
)

const HTML_TAG_PATTERN = /(<[^>]*>)/

export {
  EUR_SEK_EXCHANGE_RATE,
  EUR_CURRENCY_CODE,
  CURRENCY_SYMBOLS,
  SUB_UNIT_DECIMALS,
  SPACE_PATTERN,
  SEK_AMOUNT_PATTERN,
  HTML_TAG_PATTERN,
}
